import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select-country-list";
import "../../components/RegisterPage/RegisterPage.css"; // reuse same styling
import "./RegisterOfflinePage.css"; // reuse same styling
import { PAYMENT_LINK } from "../../config/payment";

const RegisterOfflinePage = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [university, setUniversity] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role] = useState("user");
  const [country, setCountry] = useState("");
  const [howHeard, setHowHeard] = useState("");
  const [job, setJob] = useState("Student");
  const [jobTitle, setJobTitle] = useState("");
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [proofFile, setProofFile] = useState(null);
  const [teamMembers, setTeamMembers] = useState("");

  const [registerError, setRegisterError] = useState("");
  const [registerSuccess, setRegisterSuccess] = useState("");

  const navigate = useNavigate();
  const countryList = Select();
  const countryOptions = countryList.getData();

  const howHeardOptions = [
    { value: "Friend", label: "Friend" },
    { value: "Social Media", label: "Social Media" },
    { value: "Advertisement", label: "Advertisement" },
    { value: "Search Engine", label: "Search Engine" },
    { value: "Event", label: "Event" },
    { value: "Other", label: "Other" },
  ];

 const handleRegisterSubmit = async (e) => {
  e.preventDefault();

  if (!proofFile) {
    setRegisterError("Please upload proof of payment.");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("university", university);
    formData.append("email", registerEmail);
    formData.append("password", registerPassword);
    formData.append("confirmPassword", confirmPassword);
    formData.append("role", role);
    formData.append("country", country);
    formData.append("howHeard", howHeard);
    formData.append("job", job);
    formData.append("jobTitle", jobTitle);
    formData.append("policyAccepted", acceptPolicy);
    formData.append("proofFile", proofFile); // 🔑 must match backend field name
    formData.append("teamMembers", teamMembers); // 🔑 must match backend field name

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/auth/register-offline`,
      {
        method: "POST",
        body: formData, // no headers, browser sets boundary automatically
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error during offline registration");
    }

    setRegisterSuccess(
      "✅ Registration submitted! Your account will be activated once admin verifies your payment."
    );
    setRegisterError("");

  } catch (error) {
    setRegisterError(error.message);
    setRegisterSuccess("");
  }
};


  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleRegisterSubmit}>
        <h2>Register (Offline Payment)</h2>
        <div>
          <a href={PAYMENT_LINK} target="_blank" rel="noopener noreferrer">
            💳 Click here to pay offline: {PAYMENT_LINK}
          </a>
        </div>
        {registerError && <div className="error-message">{registerError}</div>}
        {registerSuccess && <div className="success-message">{registerSuccess}</div>}

        <div>
          <label>First Name</label>
          <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
        </div>
        <div>
          <label>Last Name</label>
          <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        </div>
        <div>
          <label>Are you a ...</label>
          <select value={job} onChange={(e) => setJob(e.target.value)} required>
            <option value="Student">Student</option>
            <option value="Professional">Professional</option>
          </select>
        </div>
        {job === "Student" && (
          <div>
            <label>University</label>
            <input type="text" value={university} onChange={(e) => setUniversity(e.target.value)} required />
          </div>
        )}
        {job === "Professional" && (
          <div>
            <label>Job Title</label>
            <input type="text" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} required />
          </div>
        )}
          <div>
  <label>Team Members (optional)</label>
  <input
    type="text"
    value={teamMembers}
    onChange={(e) => setTeamMembers(e.target.value)}
    placeholder="Enter names separated by commas"
  />
</div>

        <div>
          <label>Email</label>
          <input type="email" value={registerEmail} onChange={(e) => setRegisterEmail(e.target.value)} required />
        </div>
        <div>
          <label>Password</label>
          <input type="password" value={registerPassword} onChange={(e) => setRegisterPassword(e.target.value)} required />
        </div>
        <div>
          <label>Confirm Password</label>
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
        </div>
        <div>
          <label>Country</label>
          <select value={country} onChange={(e) => setCountry(e.target.value)} required>
            <option value="">Select Country</option>
            {countryOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
        <div>
          <label>How did you hear about us?</label>
          <select value={howHeard} onChange={(e) => setHowHeard(e.target.value)} required>
            <option value="">Select an Option</option>
            {howHeardOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>

        <div>
          <label>Upload Proof of Payment</label>
          <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => setProofFile(e.target.files[0])} required />
        </div>

        <div className="policy-check">
          <input type="checkbox" checked={acceptPolicy} onChange={() => setAcceptPolicy(!acceptPolicy)} required />
          <label>
            I accept the <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">terms and conditions</a>
          </label>
        </div>
        <button className="auth-button" type="submit">Register</button>
      </form>
    </div>
  );
};

export default RegisterOfflinePage;
